import React from 'react';
import CrmCommunicationTicketsList from './CrmCommunicationTicketsList';
import { CRM_COMM_PAGE_MY_BUSINESS_BY_STATE } from '../../utils/crmCommunicationTableColumns';

export const CRM_COMM_MASK_MY_BUSINESS_BY_STATE = 'cust027';

/** Môj obchod → Podľa stavu (cust027): CRM dopyty priradeného obchodníka (quote_request, trader_business_scope). */
export default function CustomerMyBusinessByStateList(props) {
  return (
    <CrmCommunicationTicketsList
      {...props}
      crmTicketsLayout
      stateListLayout
      types="quote_request"
      mineOnlyDefault={false}
      traderBusinessScope
      listPageKey={CRM_COMM_PAGE_MY_BUSINESS_BY_STATE}
      maskCode={CRM_COMM_MASK_MY_BUSINESS_BY_STATE}
    />
  );
}
